import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import Loader from "../../common/components/Loader/Loader";
import useErrorLogger from "../../common/hooks/useErrorLogger";
import { SplitTreatments } from "@splitsoftware/splitio-react";
import {
    startMainQuestions,
    setCurrentPageProgress
} from "../api/ApiAppForm";
import { FeatureFlag } from "../../compare/enums/FeatureFlags";
import { PageType } from "../enums/PageType";
import { AppFormControllerContext } from "../providers/AppFormProvider";
import { IPageInfo } from "../interfaces/IAppFormData";


const AFLandingPage: React.FC = ({ children }) => {
    const history = useHistory();

    const ErrorLogger = useErrorLogger();
    const [isInErrorState, setIsInErrorState] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [applicantToken, setApplicantToken] = useState("");
    const { actions, selectors } = useContext(AppFormControllerContext);

    const handleCreateApplication = (): void => {
        setLoading(true);
        const applicants = selectors.getApplicantList();
        const params = {
            quoteGroupId: selectors.getQuoteGroupId(),
            applicationId: selectors.getApplicationId(),
            providerId: selectors.getInsurerId(),
            applicants
        };
        startMainQuestions(params)
            .then((res) => {
                if (!res?.applicants || !res?.applicants?.length) return;
                actions.setApplicationId(res?.applicationId);
                actions.setApplicationToken(res?.applicationToken);
                actions.setApplicantList(res?.applicants)
                const pageInfo : IPageInfo = {
                    pageType: PageType.AppForm,
                    currentClientNumber: 1
                }
                setCurrentPageProgress(res?.applicationId, selectors.getQuoteGroupId(), pageInfo
                )
                history.push(`/app-form/details/${applicantToken}`);
            })
            .catch((err) => {
                ErrorLogger.Log(err, {
                    source: "App Form Session Container - Create"
                });
                setIsInErrorState(true);
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (!isLoading) {
            handleCreateApplication()
        }
    }, [applicantToken]);

    return (
        <SplitTreatments names={Object.values(FeatureFlag)}>
            {({ isReady }) => {
                /* Pre-load all the treatments */
                if (window.splitioFactory && (!isReady || isLoading || !applicantToken))
                    return <Loader size="full-page" />;
                return <React.Fragment>{children}</React.Fragment>;
            }}
        </SplitTreatments>
    );
};

export default AFLandingPage;
